import 'phaser'
import { common } from '../main/common-sidecar'
import { l } from '../lib/imports'
import { sliceRawFrame } from '../main/spriteMap'

export interface IFontChar {
  y: number
  x: number
  h: number
  w: number
  frame: Phaser.Textures.Frame | null
}
export interface IFontData {
  data: { [k: string]: IFontChar }
  spaceWidth: number
  name: string
  widthAdjust: number
}

const objs: IFontData[] = []

export function create(
  name: string,
  options: {
    spaceWidth: number
    widthAdjust: number
  },
): IFontData {
  let scene = common.getPhaserScene()
  let json = scene.cache.json.get(name + '-font-data')
  console.log('load font json', name + '-font-data', json)

  let data: { [k: string]: IFontChar } = {}

  l.forEach(json.data, (c) => {
    data[c.c] = {
      x: c.x,
      y: c.y,
      w: c.w - 2,
      h: json.height,
      frame: null,
    }
  })

  let obj: IFontData = {
    name,
    data,
    spaceWidth: options.spaceWidth || json.spaceWidth,
    widthAdjust: options.widthAdjust,
  }
  objs.push(obj)
  return obj
}

export function getFrame(obj: IFontData, letter: string) {
  let d = obj.data[letter]
  if (!d) {
    return null
  }
  let spread = 2
  if (!d.frame) {
    // console.log('slicing', letter, d.x, d.y, d.w, d.h)
    d.frame = sliceRawFrame(
      obj.name + '-font',
      d.x - spread,
      d.y - spread,
      d.w + spread + spread,
      d.h + spread + spread - 2,
    )
  }
  return d.frame
}
